module.exports = __webpack_public_path__ + "img/a.06552cf4.png";